module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('h2', {
    staticClass: "chapterTitle"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/content#ch_03"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("AY")]), _vm._v(" 22, 2009"), _c('br'), _vm._v(" S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("TATEN")]), _vm._v(" I"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("SLAND")]), _vm._v(", N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EW")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ORK")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("C")])]), _vm._v("onsuela Lopez was worn-out and in pain. She was at the stern of the Staten Island ferry, sitting at her usual home-bound spot near the exit so she could disembark quickly. If she missed the 10:45 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("P.M.")]), _vm._v(" number 51 bus, she had a long wait at the bus station at St. George Terminal for the next one. The nine-thousand-horsepower diesel engines sent vibrations through her slight body, making her sleepy, but she was too suspicious of her fellow passengers to close her eyes lest her pocketbook disappear.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She propped her swollen left ankle on the plastic bench but rested her heel on a newspaper. Putting her shoe directly on the bench would be rude and disrespectful. She had sprained her ankle when she tripped on her own vacuum cleaner cord. She was an office cleaner in lower Manhattan and this was the end of a long day and a long week. It was a blessing that the accident happened on a Friday so she’d have the weekend to recover. She couldn’t afford to miss a day of work and prayed that she would be fine by Monday. If she was still in pain on Saturday night, she would go to early mass on Sunday and beg the Virgin Mary to help her heal quickly. She also wanted to show Father Rochas the odd postcard she had received and allay her fears about it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Consuela was a plain-looking woman who spoke little English, but she was young and had a nice figure, and so "), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("was always on guard against advances. A few rows away, facing her, an Hispanic youth in a gray sweatshirt kept smiling at her, and although she was initially uncomfortable, something about his white teeth and animated eyes induced her to give him a polite smile in return. That was all it took. He introduced himself and spent the last ten minutes of the journey seated beside her, sympathizing with her injury.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("When the ferry docked she limped off, resisting his offer of support. He attentively followed a few paces behind even though she was moving at a turtle’s pace. He offered her a ride home but she declined—it was out of the question. But since the ferry was a few minutes late and her egress was so slow, she missed her bus and reconsidered. He seemed like a nice guy. He was funny and respectful. She accepted, and when he left to get his car from the parking garage, she crossed herself for insurance.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As they neared the turnoff to her house on Fingerboard Road, his mood hardened and she became worried. The worry turned to fear as he sped past her street and ignored her protestations. He kept driving mutely on Bay Street until he made a hard left, heading for the Arthur Von Briesen Park.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At the end of the dark road she was crying and he was shouting and waving a folding knife. He forced her out of the car and pulled her by the arm, threatening to hurt her if she called out. He no longer cared about her sore ankle. He pulled her at running speed through the bushes toward the water. She winced in pain but was too frightened to make a noise.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("The dark massive superstructure of the Verrazano-Narrows Bridge was ahead of them, like some sort of malevolent presence. There wasn’t a soul in sight. In a wooded clearing, he threw her onto the ground and harshly pulled her pocketbook from her grasp. She started sobbing and he ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("told her to shut up. He rifled through her belongings and pocketed the few dollars she had. Then he found the plain white postcard addressed to her with a hand-drawn picture of a coffin and the date, May 22, 2009. He looked at it and smiled sadistically.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Usted me piensa le envió esto?”")]), _vm._v(" he asked. Do you think I sent you this?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“No sé,”")]), _vm._v(" she sobbed, shaking her head.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Bien, le estoy enviando esto,”")]), _vm._v(" he said, laughing and un-buckling his belt. Well, I’m sending you this.")])])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page18"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9479aaa4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch03.vue
// module id = 72
// module chunks = 0